import { render, staticRenderFns } from "./TheaterPerformancesContainer.vue?vue&type=template&id=443eee36&scoped=true"
import script from "./TheaterPerformancesContainer.vue?vue&type=script&lang=js"
export * from "./TheaterPerformancesContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterPerformancesContainer.vue?vue&type=style&index=0&id=443eee36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443eee36",
  null
  
)

export default component.exports